import common from "./common";
import workAnalyzer from "./workAnalyzer";
import colorNames from "./colorNames";
import componentNames from "./componentNames";
import objectNames from "./objectNames";
import modals from "./modals";
import itemsList from "./Itemslist";
import settingNames from "./settingNames";
import rooms from "./rooms";

const LANGUAGES = ["hu", "ro", "en"];

function mergeTranslations(...modules) {
  const result = {};
  for (const lang of LANGUAGES) {
    result[lang] = {};
    for (const mod of modules) {
      Object.assign(result[lang], mod[lang] || {});
    }
  }
  return result;
}

const translations = mergeTranslations(
  common,
  workAnalyzer,
  colorNames,
  componentNames,
  objectNames,
  modals,
  itemsList,
  settingNames,
  rooms
);

export default translations;
